import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import {userRegister} from "../../services/userRegister";
import {marketRegister} from "../../services/marketRegister";
import Basket from "../../components/basket/component";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import SignupAdsGoogle from "../../components/signup-ads-google/component";
import SignupAdsBing from "../../components/signup-ads-bing/component";
import SignupAdsFacebook from "../../components/signup-ads-facebook/component";
import SignupAdsInstagram from "../../components/signup-ads-instagram/component";
import SignupAdsTiktok from "../../components/signup-ads-tiktok/component";
import SignupAdsSnapchat from "../../components/signup-ads-snapchat/component";
import SignupAdsGoogleDisplay from "../../components/signup-ads-google-display/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import BoosterHeaderSecond from "../../components/booster-header-second/component";
import {scraperRegister} from "../../services/scraperRegister";
import {carouselRegister} from "../../services/carouselRegister";
import {videoRegister} from "../../services/videoRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {flowRegister} from "../../services/flowRegister";
import {canvasRegister} from "../../services/canvasRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {blurRegister} from "../../services/blurRegister";
import {imagesRegister} from "../../services/imagesRegister";

class BoosterAds extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isLoadingButton: false,
            channels: null,
            available_channels: null,
            selected: {},
            vat: 0,
            currency: null,
            image: null,
            quotes: null,
            industry: null,
            temp_industry: null,
            markets: [],
            durations: [],
            regions: [],
            market: {},
            lockin_plans: null,
            website: null,
            modal: false,
            low_traffic_modal: false,
            admin: false,
            branding: false,
            inhouse: false,
            impressions: 0,
            clicks: 0,
            duration: 0,
            plans: null,
            plan: null,
            budget: null,
            service_fee_fixed: null,
            service_fee_percentage: null,
            error: false,
            video: null,
            available_regions: [],
            market_channels: {}
        };
        this._updateBudget = this._updateBudget.bind(this);
        this._selectChannel = this._selectChannel.bind(this);
        this._removeChannel = this._removeChannel.bind(this);
        this._selectDuration = this._selectDuration.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateUser();
        this._updateData();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/ads');
            ReactGA4.send({ hitType: "pageview", page: "/booster/ads" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

        try{
            let main_image = imagesRegister.getMain();
            if(main_image){
                blurRegister.create(main_image.original);
            }
        }catch (e) {}

        carouselRegister.create();
        videoRegister.create();
        canvasRegister.create("instagram");
        canvasRegister.create("facebook");

    }

    componentDidMount() {
        let token = tokenRegister.getToken();
        if(!token){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }
    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({
                    admin: user.reseller,
                    inhouse: user.inhouse
                });
            }
            if (user.socialData) {
                this.setState({
                    branding: user.socialData.branding ? user.socialData.branding : false
                });
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateData() {
        try {
            let stored_data = cartRegister.get();
            if (stored_data.admin_image) {
                if (!stored_data.admin_image.web_url) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/booster/images");
                }
            }
            if (stored_data.industry && (stored_data.admin_image || stored_data.image) && (stored_data.quotes || stored_data.admin_quotes)) {
                this.setState({
                    industry: stored_data.industry,
                    market: salesChannelRegister.get('market'),
                    currency: salesChannelRegister.get('currency'),
                    vat: salesChannelRegister.get('vat'),
                    available_channels: JSON.parse(salesChannelRegister.get('channels')),
                    market_channels: JSON.parse(salesChannelRegister.get('available_channels')),
                    country_region: JSON.parse(salesChannelRegister.get('country_region')),
                    durations: JSON.parse(salesChannelRegister.get('durations')),
                    regions: stored_data.regions ? stored_data.regions : [],
                    image: stored_data.image ? stored_data.image : stored_data.admin_image,
                    quotes: stored_data.quotes ? stored_data.quotes : stored_data.admin_quotes,
                    budget: stored_data.budget ? stored_data.budget : null,
                    duration: stored_data.duration ? stored_data.duration : salesChannelRegister.get('default_duration'),
                    plan: stored_data.plan ? stored_data.plan : null,
                    optimization_goal: stored_data.options === "instant"?2:1,
                    channels: stored_data.channels ? stored_data.channels : {},
                    lockin_plans: stored_data.lockin_plans ? stored_data.lockin_plans : null,
                    service_fee_percentage: stored_data.servicefee_percentage,
                    service_fee_fixed: stored_data.servicefee_fixed
                }, () => {

                    console.log(stored_data.options);

                    //SET DEFAULT 10 DAYS
                    if(!this.state.inhouse && !stored_data.duration && Array.isArray(this.state.durations) && this.state.durations.filter((item) => {
                        return item === 10
                    }).length > 0){
                        this.setState({
                            duration: 10
                        })
                    }

                    if (this.state.available_channels) {
                        /*for (let i in this.state.market.channels) {
                            this.state.channels[this.state.market.channels[i]] = {selected: this.state.channels[this.state.market.channels[i]] ? this.state.channels[this.state.market.channels[i]].selected : false};
                        }
                        */
                        for (let i = 0; i < this.state.available_channels.length; i++) {
                            if (this.state.available_channels[i] === "fb") {
                                this.state.available_channels[i] = "facebook";
                            }
                            this.state.channels[this.state.available_channels[i]] = {
                                selected: this.state.channels[this.state.available_channels[i]] ? this.state.channels[this.state.available_channels[i]].selected : false,
                                index: this.state.channels[this.state.available_channels[i]] ? this.state.channels[this.state.available_channels[i]].index : 0
                            };

                        }

                        //SET TRUE IS NOT SELECTED
                        let some_selected = false;
                        for(let key in this.state.channels){
                            if(this.state.channels[key].selected){
                                some_selected = true;
                            }
                        }
                        if((!some_selected && !this.state.inhouse) || (!some_selected && this.state.inhouse && this.state.branding)){
                            for(let key in this.state.channels){
                                this.state.channels[key].selected = true;
                            }
                        }

                        //SET REGIONS
                        try{

                            if(this.state.regions.length < 1){

                                let countries = [];
                                let country_region = JSON.parse(salesChannelRegister.get("country_region"));
                                countries.push(country_region);
                                this.state.regions = countries;
                            }

                            this.setState({
                                regions: this.state.regions,
                                channels: this.state.channels
                            }, () => {

                                //Override channels from user socialData
                                try {
                                    const user = userRegister.get();
                                    if (user && user.socialData) {
                                        const sd = user.socialData;
                                        const map = { fb: "facebook", instagram: "instagram", google: "google", bing: "bing" };

                                        for (let shortKey in map) {
                                            const fullKey = map[shortKey];

                                            if (typeof sd[shortKey] === "boolean") {

                                                this.state.market_channels[shortKey] = sd[shortKey];

                                                if (sd[shortKey] === false && this.state.channels[fullKey]) {
                                                    this.state.channels[fullKey].selected = false;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {}

                                if (!this.state.budget) {
                                    this._updateNewBudget(salesChannelRegister.get('market'), salesChannelRegister.get('default_language'), salesChannelRegister.get('name'), this.state.industry.id);
                                } else {
                                    this.setState({isLoading: false});
                                }
                            });

                            //SET BUDGET AUTO
                            if(this.state.budget){
                                for (var key in this.state.budget) {
                                    this.state.budget[key].auto = true;
                                }
                            }

                            //GET WEBSITE
                            try {
                                if(flowRegister.getValue("website")){
                                    this.setState({website: flowRegister.getValue("website")});
                                }
                            }catch (e) {}

                        }catch (e) {}
                    } else {
                        this.setState({error: true, isLoading: false});
                    }
                });
            } else {
                if(salesChannelRegister.get('name') === "yieldlock"){
                    let view = quotesRegister.getView();
                    if (view === "custom") {
                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans-custom");
                    } else {
                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans");
                    }
                }else{
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/theme");
                }
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateBudget(value) {
        if (value) {
            this.setState({budget: value}, () => {
                cartRegister.setBudget(this.state.budget);
            });
        }
    }

    _updateNewBudget(market, lang, saleschannel, industry) {
        if (this.state.country_region) {

            let regions = this.state.regions.map(function (item) {
                return item.id;
            }).join(",");

            dataRegister.budget(market, lang, saleschannel, industry, regions, [], this.state.duration, this.state.optimization_goal).then((data) => {
                if (!data.errors) {

                    //RESET RELATED INDUSTRIES AND REGIONS
                    cartRegister.setRelated([]);
                    cartRegister.setRegions([]);

                    let budget = {};

                    //REMOVE LOCKIN
                    if ("lockin_plans" in data) {
                        this.state.lockin_plans = data.lockin_plans;
                        delete data.lockin_plans;
                        //PARSE LOCKIN PLANS
                        let plans = [];
                        let biggest_plan = {months: 0, free_months: 0};
                        if (this.state.lockin_plans.months && Array.isArray(this.state.lockin_plans.months)) {
                            for (let i = 0; i < this.state.lockin_plans.months.length; i++) {
                                let free_months = 0;
                                if (this.state.lockin_plans.months[i] > 5 && this.state.lockin_plans.months[i] < 12) {
                                    free_months = 1;
                                } else if (this.state.lockin_plans.months[i] > 11) {
                                    free_months = 2;
                                }
                                //SET BIGGEST PLAN AS DEFAULT
                                if (biggest_plan.months < this.state.lockin_plans.months[i]) {
                                    biggest_plan = {
                                        "months": this.state.lockin_plans.months[i],
                                        "free_months": free_months
                                    };
                                }
                                plans.push({"months": this.state.lockin_plans.months[i], "free_months": free_months})
                            }
                            cartRegister.lockinPlans(plans);
                            cartRegister.setLockinPlan(biggest_plan);
                        }
                    }

                    // REMOVE SERVICE_FEE PROPERTIES
                    if ("service_fee_percentage" in data) {
                        this.state.service_fee_percentage = data.service_fee_percentage;
                        delete data.service_fee_percentage;
                    }
                    if ("service_fee_fixed" in data) {
                        this.state.service_fee_fixed = data.service_fee_fixed;
                        delete data.service_fee_fixed;
                    }

                    //REMOVE BUDGET DURAION
                    if ("campaign_duration" in data) {
                        delete data.campaign_duration;
                    }

                    this.setState({
                        service_fee_fixed: this.state.service_fee_fixed,
                        service_fee_percentage: this.state.service_fee_percentage,
                        lockin_plans: this.state.lockin_plans
                    });

                    for (let channel in data) {
                        if (channel === "fb") {
                            channel = "facebook";
                            budget[channel] = this._reCalcBudgetTemp(JSON.parse(JSON.stringify(data)), "fb");
                        } else {
                            budget[channel] = this._reCalcBudgetTemp(JSON.parse(JSON.stringify(data)), channel);
                        }
                    }

                    this.setState({
                        budget: budget,
                        plan: marketRegister.lowPlan(),
                        isLoading: false,
                    }, () => {
                        cartRegister.setOfferServiceFeePercentage(this.state.service_fee_percentage);
                        cartRegister.setOfferServiceFeeFixed(this.state.service_fee_fixed);
                        cartRegister.setBudget(this.state.budget);
                        cartRegister.setPlan(this.state.plan);
                    });

                }
            }, (error) => {
                this.setState({error: true});
            });
        } else {
            this.setState({error: true});
        }
    }

    _reCalcBudgetTemp(data, channel) {

        //SET AUTO PROPERTY (ON)
        data[channel].auto = true;

        data[channel].budget_available = data[channel].budget_cap;
        data[channel].budget = data[channel].budget_cap;

        /*
        if(data[channel].social){
            data[channel].budget_available = data[channel].budget_cap;
            data[channel].budget = data[channel].budget_cap;
        }
        */

        /*
        if(data[channel].budget_available > data[channel].budget_cap){
            data[channel].budget_available = data[channel].budget_cap;
            data[channel].budget = data[channel].budget_cap;
        }
        */

        //SET INITIAL SPEND
        if (data[channel].budget_available > (data[channel].min_daily * this.state.duration)) {
            data[channel].spend = data[channel].min_daily * this.state.duration;
            data[channel].min_budget = data[channel].min_daily * this.state.duration;
            data[channel].budget = data[channel].budget_available;
        } else {
            data[channel].budget_available = data[channel].min_daily * this.state.duration;
            data[channel].spend = data[channel].min_daily * this.state.duration;
            data[channel].min_budget = data[channel].min_daily * this.state.duration;
            data[channel].budget = data[channel].min_daily * this.state.duration;
        }

        return data[channel];

    }

    _selectChannel(option) {
        try {
            let index = 0;
            this.state.channels[option].selected = !this.state.channels[option].selected;
            if (!this.state.channels[option].selected) {
                delete this.state.channels[option].index;
            } else {
                Object.keys(this.state.channels).map((item) => {
                    if (this.state.channels[item].selected && this.state.channels[item].index > index) {
                        index = this.state.channels[item].index;
                    }
                });
                index++;
                this.state.channels[option].index = index;
            }
            this.state.budget[option].spend = this.state.budget[option].min_budget;
            this.setState({channels: this.state.channels, budget: this.state.budget}, () => {
                cartRegister.setChannels(this.state.channels);
                cartRegister.setBudget(this.state.budget);
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _selectDuration(value){
        this.setState({duration: value, isLoading: true}, () => {
            cartRegister.setDuration(this.state.duration);
            this._updateNewBudget(salesChannelRegister.get('market'), salesChannelRegister.get('default_language'), salesChannelRegister.get('name'), this.state.industry.id);
        });
    }

    _removeChannel(option) {
        this.state.channels[option].selected = false;
        delete this.state.channels[option].index;
        this.setState({channels: this.state.channels}, () => {

            if (Object.keys(this.state.channels).filter((item) => {
                return this.state.budget[item].search && this.state.channels[item].selected
            }).length < 1) {

                cartRegister.setTargetSlogans(null);
                cartRegister.setRelated(null);

                //CHECK IF SOCIAL ADVANCED EXIST
                let cart = cartRegister.getCheckout();
                if(!cart.targets && !cart.interests && !cart.age_range){
                    cartRegister.setPlan(marketRegister.lowPlan());
                }

            }

            if (Object.keys(this.state.channels).filter((item) => {
                return this.state.budget[item].social && this.state.channels[item].selected
            }).length < 1) {

                cartRegister.setAgeRange(null);
                cartRegister.setTargets(null);
                cartRegister.setInterests(null);

                //CHECK IF SEARCH ADVANCED EXIST
                let cart = cartRegister.getCheckout();
                if(!cart.target_slogans){
                    cartRegister.setPlan(marketRegister.lowPlan());
                }

                //UPDATE PLAN
                let stored_data = cartRegister.get();
                if (stored_data.plan) {
                    this.setState({plan: stored_data.plan});
                }
            }
            cartRegister.setChannels(this.state.channels);
        });
    }

    _setDuration(data) {
        if (data && (data !== this.state.duration)) {
            this.setState({duration: data, isLoading: true}, () => {
                cartRegister.setDuration(data);
                this._updateNewBudget(salesChannelRegister.get('market'), salesChannelRegister.get('default_language'), salesChannelRegister.get('name'), this.state.industry.id);
            });
        }
    }

    _next(skip) {
        let channels = {};
        for (let key in this.state.channels) {
            try {
                if (this.state.channels[key].selected) {
                    channels[key] = this.state.channels[key];
                }
            }catch (e) {}
        }
        if (Object.keys(channels).length !== 0 && channels.constructor === Object) {
            if (!skip && (this.state.market_channels.fb || this.state.market_channels.instagram)) {
                let low_flag = true;
                try {
                    if (!this.state.channels["facebook"].selected && !this.state.channels["instagram"].selected) {
                        for (var key in this.state.budget) {
                            if (this.state.budget[key].low_traffic_flag === 0) {
                                low_flag = false
                            }
                        }
                    } else {
                        low_flag = false;
                    }
                }catch (e) {
                    low_flag = false;
                }
                if (low_flag) {
                    this.setState({low_traffic_modal: true});
                } else {
                    cartRegister.setDuration(this.state.duration);
                    cartRegister.setBudget(this.state.budget);
                    cartRegister.setChannels(this.state.channels);
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/filter");
                }
            } else {
                cartRegister.setDuration(this.state.duration);
                cartRegister.setBudget(this.state.budget);
                cartRegister.setChannels(this.state.channels);
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/filter");
            }
        }
    }

    _back(){
        if(salesChannelRegister.get('name') === "yieldlock"){
            let view = quotesRegister.getView();
            if (view === "custom") {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans-custom");
            } else {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans");
            }
        }else{
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/theme");
        }
    }

    _decreaseSpend(key) {
        let spend = this.state.budget[key].spend - 100;
        if ((spend - this.state.budget[key].min_budget) <= 0) {
            this.state.budget[key].spend = this.state.budget[key].min_budget;
            this.setState({budget: this.state.budget}, () => {
                cartRegister.setBudget(this.state.budget);
            });
        } else if (this.state.budget[key].min_budget <= spend) {
            this.state.budget[key].spend = this.state.budget[key].spend - 100;
            this.setState({budget: this.state.budget}, () => {
                cartRegister.setBudget(this.state.budget);
            });
        }
    }

    _increaseSpend(key) {
        let spend = this.state.budget[key].spend + 100;
        if (spend >= this.state.budget[key].budget) {
            this.state.budget[key].spend = this.state.budget[key].budget_available;
            this.setState({budget: this.state.budget}, () => {
                cartRegister.setBudget(this.state.budget);
            });
        } else if (this.state.budget[key].budget >= spend) {
            this.state.budget[key].spend = this.state.budget[key].spend + 100;
            this.setState({budget: this.state.budget}, () => {
                cartRegister.setBudget(this.state.budget);
            });
        }
    }

    _renderImpressionsTotal() {
        let impressions = 0;
        if (this.state.budget) {
            for (let key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    if(this.state.budget[key].budget_available > this.state.budget[key].budget_cap){
                        impressions = impressions + (this.state.budget[key].budget_cap / this.state.budget[key].cpi)
                    }else if(this.state.budget[key].budget_available < (this.state.budget[key].min_daily * this.state.duration)){
                        impressions = impressions + ((this.state.budget[key].min_daily * this.state.duration) / this.state.budget[key].cpi)
                    }else{
                        impressions = impressions + (this.state.budget[key].budget_available / this.state.budget[key].cpi)
                    }
                }
            }
            return Math.ceil(impressions);
        } else {
            return ("...");
        }
    }

    _renderImpressionsBySpend() {
        let impressions = 0;
        if (this.state.budget) {
            for (let key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    impressions = impressions + (this.state.budget[key].spend / this.state.budget[key].cpi);
                }
            }
            return Math.ceil(impressions);
        } else {
            return ("...");
        }
    }

    _renderLeadsTotal() {
        let clicks = 0;
        if (this.state.budget) {
            for (let key in this.state.budget) {
                try {
                    if (this.state.channels[key].selected) {
                        if(this.state.budget[key].budget_available > this.state.budget[key].budget_cap){
                            clicks = clicks + (this.state.budget[key].budget_cap / this.state.budget[key].cpc)
                        }else if(this.state.budget[key].budget_available < (this.state.budget[key].min_daily * this.state.duration)){
                            clicks = clicks + ((this.state.budget[key].min_daily * this.state.duration) / this.state.budget[key].cpc)
                        }else{
                            clicks = clicks + (this.state.budget[key].budget_available / this.state.budget[key].cpc)
                        }
                    }
                }catch (e) {}
            }
            return Math.ceil(clicks);
        } else {
            return ("...");
        }
    }

    _renderLeadsBySpend() {
        let clicks = 0;
        if (this.state.budget) {
            for (let key in this.state.channels) {
                try {
                    if (this.state.channels[key].selected) {
                        clicks = clicks + (this.state.budget[key].spend / this.state.budget[key].cpc);
                    }
                }catch (e) {}
            }
            return Math.ceil(clicks);
        } else {
            return ("...");
        }
    }

    _renderReach() {
        let reach = 0;
        for(let i = 0; i < this.state.regions.length; i++){
            try{
                if(this.state.regions[i].population){
                    reach = reach + +this.state.regions[i].population;
                }
            }catch (e) {}
        }
        return reach;
    }

    _renderPartialBudget() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                try {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }catch (e) {}
            }

            // IF FIXED FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this.state.service_fee_fixed;
            }

            //IF PERCENTAGE SERVICE FEE
            if (this.state.service_fee_percentage) {
                budget = budget + this._renderPercentageFee();
            }

            /*
            //IF VAT
            if(this.state.vat){
                budget = budget + this._renderVat();
            }
            */

            return budget;
        }
    }

    _renderPercentageFee() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                try {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }catch (e) {}
            }
            return budget * (this.state.service_fee_percentage / 100);
        }
    }

    _renderVat() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                try {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }catch (e) {}
            }

            // IF FIXED FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this.state.service_fee_fixed;
            }

            //IF PERCENTAGE SERVICE FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this._renderPercentageFee();
            }

            return budget * (this.state.vat / 100);
        }
    }

    _renderMinimumBudget() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                try {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].min_budget;
                    }
                }catch (e) {}
            }
            return budget;
        } else {
            return ("...");
        }
    }

    _renderSelectedChannels() {
        let selected = false;
        for (let key in this.state.channels) {
            try {
                if (this.state.channels[key].selected) {
                    selected = true;
                }
            }catch (e) {}
        }
        return selected;
    }

    _renderCustomIndustry(instagram){

        if(instagram){
            return flowRegister.getValue("ads_title_instagram");
        }else{
            return flowRegister.getValue("ads_title_facebook");
        }

        /*
        try {

            let scraper_data = JSON.parse(scraperRegister.get());
            let cart = cartRegister.get();
            let region = null;
            let display_region = JSON.parse(JSON.stringify(cart.display_region));
            if(scraper_data.region_grid){
                if(!display_region){
                    let lowest = 0;
                    for(let key in scraper_data.region_grid){
                        if(scraper_data.region_grid[key].value !== "-1" && scraper_data.region_grid[key].value && scraper_data.region_grid[key].level < 4){
                            if(+key > +lowest){
                                lowest = key;
                            }
                        }
                    }
                    region = JSON.parse(scraper_data.region_grid[lowest].value);
                }else{
                    region = display_region;
                }
                try {
                    if(scraper_data.additional_information.facts.address){
                        region.name = region.name + ', ' + scraper_data.additional_information.facts.address;
                        try {
                            if (region.name.length > 24) {
                                region.name = region.name.substr(0, 24);
                                region.name.trim();
                                region.name = region.name + "..";
                            }
                        } catch (e) {}
                    }
                }catch (e) {}
            }

            //SET PRICE AND CURRENCY
            let company_name = 0;
            let currency = null;

            company_name = scraper_data.additional_information.facts.price;
            currency = scraper_data.additional_information.facts.currency;

            if(+company_name > 0){
                //var parts = company_name.toString().split(".");
                //parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                //company_name = parts.join(".");
                company_name = currency +" "+ this._renderNumbers(company_name)
            }else{
                company_name = "Price on request";
            }
            if(instagram){
                try{
                    if(scraper_data.additional_information.facts.listing_type.indentifier === "rent" && scraper_data.additional_information.facts.price > 0){
                        return region.name + " | " + company_name + " " + scraper_data.additional_information.facts.duration.title;
                    }else{
                        return region.name + " | " + company_name;
                    }
                }catch (e) {
                    return region.name + " | " + company_name;
                }
            }else{
                try{
                    if(scraper_data.additional_information.facts.listing_type.indentifier === "rent" && scraper_data.additional_information.facts.price > 0){
                        return this.state.industry.name + " | " + region.name + " | " + company_name + " " + scraper_data.additional_information.facts.duration.title;
                    }else{
                        return this.state.industry.name + " | " + region.name + " | " + company_name;
                    }
                }catch (e) {
                    return this.state.industry.name + " | " + region.name + " | " + company_name;
                }

            }
        }catch (e) {
            console.log(e);
            return null;
        }
        */
    }

    _renderAdImage() {
        if (this.state.image) {
            return (
                <div className={Styles.imagesContainerItem}>
                    <div className={Styles.imagesContainerItemInner}>
                        {
                            (!this.state.admin || !this.state.image.file) &&
                            <img src={this.state.image.url}/>
                        }
                        {
                            this.state.admin && this.state.image.file &&
                            <div style={{backgroundImage: "url(" + this.state.image.url + ")"}}
                                 className={Styles.imagesContainerItemInnerUploadImage}/>
                        }
                    </div>
                </div>
            )
        }
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("signup-ads", item);
    }

    render() {
        return (
            <div>
                <BoosterHeaderSecond history={this.props.history} step={1} props={this.props}/>
                {
                    this.state.low_traffic_modal && !this.state.isLoading &&
                    <div className={Styles.overlay}>
                        <div className={Styles.overlayModal}>
                            <div className={Styles.overlayModalInner}>
                                <img onClick={() => this.setState({low_traffic_modal: false})}
                                     className={Styles.overlayCloseButton}
                                     src={require("../../assets/images/close_icon.svg")}/>
                                <div>
                                    <div className={Styles.overlayModalTitle}>
                                        {this._renderText("item_19")}
                                    </div>
                                    <div className={Styles.overlayModalText}>
                                        {this._renderText("item_20")}&nbsp;
                                        {
                                            this.state.market_channels.fb &&
                                            <span className={Styles.overlayModalTextBold}>{this._renderText("item_21")}</span>
                                        }
                                        {
                                            !this.state.market_channels.fb && this.state.market_channels.instagram &&
                                            <span className={Styles.overlayModalTextBold}>{this._renderText("item_66")}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.overlayModalButtons}>
                                <div className={Styles.overlayModalButtonsItem}>
                                    <div onClick={() => this._next(true)}
                                         className={Styles.overlayModalButtonsItemButton}>
                                        {this._renderText("item_22")}
                                    </div>
                                </div>
                                {
                                    this.state.market_channels.fb &&
                                    <div className={Styles.overlayModalButtonsItem}>
                                        <div onClick={() => {
                                            this._selectChannel("facebook");
                                            this._next();
                                        }}
                                             className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                            {this._renderText("item_23")}
                                        </div>
                                    </div>
                                }
                                {
                                    !this.state.market_channels.fb && this.state.market_channels.instagram &&
                                    <div className={Styles.overlayModalButtonsItem}>
                                        <div onClick={() => {
                                            this._selectChannel("instagram");
                                            this._next();
                                        }}
                                             className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                            {this._renderText("item_23")}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.industry && this.state.quotes && this.state.image && this.state.channels && this.state.plan && this.state.currency && !this.state.isLoading && !this.state.error &&
                    <div className={Styles.containerOuter}>
                        <div className={Styles.container}>
                            {
                                !this._renderSelectedChannels() &&
                                <div className={Styles.subtitleContainer}>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.subtitleContainerText}>
                                        {this._renderText("item_2")}
                                    </div>
                                    <div className={Styles.dropdown}>
                                        <select className={Styles.dropdownSelection} value={this.state.duration}
                                                onChange={(event) => this._setDuration(event.target.value)}>
                                            {
                                                this.state.durations.sort(function(a, b){return b - a}).map((item) => {
                                                    return (
                                                        <option value={item}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownText}>{this.state.duration}</div>
                                        {
                                            salesChannelRegister.get('name') !== "yieldlock" &&
                                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === "yieldlock" &&
                                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-yl.svg")}/>
                                        }
                                    </div>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.subtitleContainerText}>
                                        {this._renderText("item_3")}
                                    </div>
                                </div>
                            }
                            {
                                this._renderSelectedChannels() &&
                                <div className={Styles.subtitleContainerTwo}>
                                <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.subtitleContainerText}>
                                    {this._renderText("item_25")}
                                </span>
                                    <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.subtitleContainerTextBold}>
                                    {this._renderNumbers(this._renderImpressionsTotal())}{" "}
                                </span>
                                    <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.subtitleContainerText}>
                                    {this._renderText("item_26")}
                                </span>
                                    <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.subtitleContainerTextBold}>
                                    {this._renderNumbers(this._renderLeadsTotal())}{" "}
                                </span>
                                    <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.subtitleContainerText}>
                                    {this._renderText("item_27")}
                                </span>
                                    {
                                        <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.subtitleContainerTextBold}>
                                        {
                                            Object.keys(this.state.channels).filter((key) => {
                                                return this.state.channels[key].selected
                                            }).length
                                        }
                                    </span>
                                    }
                                    {
                                        Object.keys(this.state.channels).filter((key) => {
                                            return this.state.channels[key].selected
                                        }).length > 1 &&
                                        <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.subtitleContainerText}>
                                    {" "}{this._renderText("item_63")}
                                    </span>
                                    }
                                    {
                                        Object.keys(this.state.channels).filter((key) => {
                                            return this.state.channels[key].selected
                                        }).length < 2 &&
                                        <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.subtitleContainerText}>
                                    {" "}{this._renderText("item_64")}
                                    </span>
                                    }
                                </div>
                            }
                            <div className={Styles.contentContainer}>
                                <div className={Styles.contentContainerLeft}>
                                    {
                                        this.state.channels.google &&
                                        <SignupAdsGoogle setIndustry={this.state.industry}
                                                         setCustomIndustry={this._renderCustomIndustry()}
                                                         setQuotes={this.state.quotes}
                                                         removeChannel={this._removeChannel}
                                                         setWebsite={this.state.website}
                                                         setChannel={this.state.channels.google.selected}
                                                         selectChannel={this._selectChannel}
                                                         setAvailable={this.state.market_channels.google}
                                        />
                                    }
                                    {
                                        this.state.channels.facebook &&
                                        <SignupAdsFacebook setImage={this.state.image}
                                                           setIndustry={this.state.industry}
                                                           setCustomIndustry={this._renderCustomIndustry()}
                                                           setQuotes={this.state.quotes}
                                                           setWebsite={this.state.website}
                                                           removeChannel={this._removeChannel}
                                                           setChannel={this.state.channels.facebook.selected}
                                                           selectChannel={this._selectChannel}
                                                           setAvailable={this.state.market_channels.fb}
                                        />
                                    }
                                    {
                                        this.state.channels.bing &&
                                        <SignupAdsBing setIndustry={this.state.industry}
                                                       setCustomIndustry={this._renderCustomIndustry()}
                                                       setQuotes={this.state.quotes}
                                                       removeChannel={this._removeChannel}
                                                       setWebsite={this.state.website}
                                                       setChannel={this.state.channels.bing.selected}
                                                       selectChannel={this._selectChannel}
                                                       setAvailable={this.state.market_channels.bing}
                                        />
                                    }
                                    {
                                        this.state.channels.instagram &&
                                        <SignupAdsInstagram setImage={this.state.image}
                                                            setIndustry={this.state.industry}
                                                            setCustomIndustry={this._renderCustomIndustry(true)}
                                                            setQuotes={this.state.quotes}
                                                            removeChannel={this._removeChannel}
                                                            setChannel={this.state.channels.instagram.selected}
                                                            selectChannel={this._selectChannel}
                                                            setAvailable={this.state.market_channels.instagram}
                                        />
                                    }
                                    <SignupAdsTiktok setImage={this.state.image}
                                                            setIndustry={this.state.industry}
                                                            setCustomIndustry={this._renderCustomIndustry(true)}
                                                            setQuotes={this.state.quotes}
                                                            removeChannel={this._removeChannel}
                                                            setChannel={false}
                                                            selectChannel={this._selectChannel}
                                                            setAvailable={false}
                                    />
                                    <SignupAdsSnapchat setImage={this.state.image}
                                                            setIndustry={this.state.industry}
                                                            setCustomIndustry={this._renderCustomIndustry(true)}
                                                            setQuotes={this.state.quotes}
                                                            removeChannel={this._removeChannel}
                                                            setChannel={false}
                                                            selectChannel={this._selectChannel}
                                                            setAvailable={false}
                                    />
                                    <div
                                        className={
                                            cx(Styles.contentContainerLeftItemButton,
                                                {
                                                    [Styles.buttonActive]: this._renderSelectedChannels()
                                                })
                                        }
                                        onClick={() => this._next()}>
                                        {this._renderText("item_12")}
                                    </div>
                                    <div
                                        className={
                                            cx(Styles.mobileButton,
                                                {
                                                    [Styles.buttonActive]: this._renderSelectedChannels()
                                                })
                                        }
                                        onClick={() => this._next()}>
                                        {this._renderText("item_12")}
                                        {
                                            this._renderSelectedChannels() &&
                                            <span className={Styles.mobileButtonPrice}>
                                            {this._renderNumbers(this._renderPartialBudget())}{" "}{this.state.currency.toLowerCase()}
                                        </span>
                                        }
                                    </div>
                                    <div
                                        onClick={() => this._back()}
                                        style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}}
                                        className={Styles.backButton}>
                                        {this._renderText("item_17")}
                                    </div>
                                </div>
                                <div className={Styles.contentContainerRight}>
                                    {
                                        this._renderSelectedChannels() &&
                                        <div className={Styles.contentContainerRightInner}>
                                            <Basket
                                                updateBudget={this._updateBudget}
                                                selectDuration={this._selectDuration}
                                                props={this.props}
                                                nextView={"/signup/filter"}
                                                regions={this.state.regions}
                                                serviceFeeFixed={this.state.service_fee_fixed}
                                                serviceFeePercentage={this.state.service_fee_percentage}
                                                budget={this.state.budget}
                                                channels={this.state.channels}
                                                currency={this.state.currency}
                                                plan={this.state.plan}
                                                vat={this.state.vat}
                                                durations={this.state.durations}
                                                inhouse={this.state.inhouse}
                                                duration={this.state.duration}/>
                                            <div onClick={() => this._next()} className={
                                                cx(Styles.contentContainerRightButton,
                                                    {
                                                        [Styles.buttonActive]: this._renderSelectedChannels()
                                                    })
                                            }>
                                                {this._renderText("item_12")}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
            </div>
        );
    }
}

export default BoosterAds;


// WEBPACK FOOTER //
// ./src/pages/booster-ads/component.js